import React from 'react';
import './Page.css';
import BossWindowComponent from "../componetns/menu/worldMap/BossWindowComponent";

function BossWindow() {

    return (
        <div className="main_work_field">
          <BossWindowComponent />
        </div>
    );
}

export default BossWindow;